<template>
  <BaseTemplate>
    <TabBar
      @clickLogin="formMode = 1"
      @clickRegister="formMode = 2"></TabBar>
    <Login v-if="formMode == 1"></Login>
    <MemberSave v-if="formMode == 2"></MemberSave>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import TabBar from '@/components/pages/Login/TabBar.vue';
import Login from '@/components/pages/Login/Login.vue';
import MemberSave from '@/components/pages/Login/MemberSave.vue';

export default {
  components: {
    BaseTemplate,
    TabBar,
    Login,
    MemberSave,
  },

  data: () => ({
    formMode: 1,
  }),

  created() {
    const { mode } = this.$route.query;
    if (mode) {
      this.formMode = mode;
    }
  },
};
</script>
